import { ICartProps, ILineItem } from '../CartContext.types';
import { DefaultPromo, IPromo } from '../../../types/Promo';

export interface IValidatePromoRequest {
    lineItems: ILineItemRequest[];
    accessories: IAccessoryRequest[];
}

export const DefaultValidatePromoRequest = (): IValidatePromoRequest => {
    return {
        lineItems: [],
        accessories: []
    };
};

export interface ILineItemRequest {
    lineNumber: number;
    device?: string;
    plan?: string;
    assurance?: boolean;
    tradeInValue?: number;
    downPayment?: number;
}

export const DefaultLineItemRequest = (): ILineItemRequest => {
    return {
        lineNumber: 0,
        device: '',
        plan: '',
        assurance: false,
        tradeInValue: 0,
        downPayment: 0
    };
};

export interface IAccessoryRequest {
    accessory: string;
    quantity: number;
}

export interface IValidatePromoResponse {
    lineItems: ILineItemPromoResponse[];
}

export interface ILineItemPromoResponse {
    lineNumber: number;
    promo: IPromo;
    isBogo: boolean;
    bogoSourceProduct: string;
    bogoSourceLineNumber: number;
}

export const DefaultLineItemPromoResponse = (): ILineItemPromoResponse => {
    return {
        bogoSourceProduct: '',
        isBogo: false,
        lineNumber: 0,
        promo: DefaultPromo(),
        bogoSourceLineNumber: 0
    };
};

export interface IPromoHook {
    calcBestPromoForLine: (lineItem: ILineItem) => void;
    calcBestPromos: (cart: ICartProps) => void;
}

export interface IPromoSummary {
    dueMonthly: number;
    dueToday: number;
    discount: number;
    hasPromo: boolean;
    promoResponse: ILineItemPromoResponse;
    hasBundleDiscount: boolean;
    bundleDiscountPromo: IPromo;
    bundleDiscount: number;
}

export const DefaultPromoSummary = (): IPromoSummary => {
    return {
        dueMonthly: 0,
        dueToday: 0,
        discount: 0,
        hasPromo: false,
        promoResponse: DefaultLineItemPromoResponse(),
        hasBundleDiscount: false,
        bundleDiscountPromo: DefaultPromo(),
        bundleDiscount: 0
    };
};
